import React from 'react';
import PropTypes from 'prop-types';
import './RescoringLegend.scss';
import { generateReactKey } from '../../../../../../utils/shared/commonUtils';

const RescoringLegend = ({ legendItems }) => (
    <section className="tro-legend">
        {legendItems.map(({ label, shortLabel, className }) => (
            <div key={generateReactKey(label)} className={`legend-item ${className}`}>
                <span className="short-text">{shortLabel}</span>
                <p className="m-0 p-0 description">{label}</p>
            </div>
        ))}
    </section>
);

RescoringLegend.defaultProps = {
    legendItems: [],
};

RescoringLegend.propTypes = {
    legendItems: PropTypes.array,
};

export default RescoringLegend;
